import React, { useContext } from "react";
import { Box, Drawer, Typography } from "@mui/material";
import { ReactComponent as Logo } from "../../../assets/svg/white-logo.svg";
import { CustomAccordion } from "../../atoms/CustomAccordion";
// import MenuIcon from "@mui/icons-material/Menu";
import { observer } from "mobx-react-lite";
import { authStore } from "../../../features/auth/store/AuthStore";

export const Navbar = observer(() => {
  const { menuIsOpened, toggleMenu } = useContext(authStore);

  return (
    <>
      <Box
        sx={{
          position: "relative",
          backgroundColor: "red",
          minWidth: "280px",
          display: { xs: "none", sm: "none", md: "block" },
        }}
      >
        <Box
          component={"nav"}
          sx={{
            width: "280px",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            position: "fixed",
            backgroundColor: "#1C2536",
            display: "flex",
            flexDirection: "column",
            zIndex: "1000",
          }}
        >
          <Box sx={{ margin: "24px" }}>
            <Box sx={{ display: "flex" }}>
              <Logo height={"40px"} width={"125px"} />
            </Box>
          </Box>
          <Box sx={{ mt: "16px", px: "16px" }}>
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "13px",
                fontWeight: "700",
                lineHeight: "1.66",
                textTransform: "uppercase",
              }}
            >
              Telegram
            </Typography>
          </Box>
          <CustomAccordion />
        </Box>
      </Box>
      <>
        {/* <MenuIcon
          sx={{
            color: "#666666",
            cursor: "pointer",
            ml: "12px",
            mt: "6px",
            display: { xs: "block", sm: "block", md: "none" },
          }}
          fontSize="large"
          onClick={() => setOpen((value) => !value)}
        /> */}
        <Drawer
          anchor={"left"}
          open={menuIsOpened}
          onClose={() => toggleMenu(!menuIsOpened)}
        >
          <Box
            sx={{
              position: "relative",
              backgroundColor: "red",
              minWidth: "280px",
              display: { xs: "block", sm: "block", md: "none" },
            }}
          >
            <Box
              component={"nav"}
              sx={{
                width: "280px",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                position: "fixed",
                backgroundColor: "#1C2536",
                display: "flex",
                flexDirection: "column",
                zIndex: "1000",
              }}
            >
              <Box sx={{ margin: "24px" }}>
                <Box sx={{ display: "flex" }}>
                  <Logo height={"40px"} width={"125px"} />
                </Box>
              </Box>
              <Box sx={{ mt: "16px", px: "16px" }}>
                <Typography
                  sx={{
                    color: "#9DA4AE",
                    fontSize: "13px",
                    fontWeight: "700",
                    lineHeight: "1.66",
                    textTransform: "uppercase",
                  }}
                >
                  Telegram
                </Typography>
              </Box>
              <CustomAccordion />
            </Box>
          </Box>
        </Drawer>
      </>
    </>
  );
});
